<template>
  <nav class="diy-sidebar" :class="sidebarStatus">
    <!-- team menu -->
    <TheSidebarMenuTeam v-if="userType === 'EMPLOYEE'" />
    <!-- client menu -->
    <TheSidebarMenuClient v-if="userType === 'CLIENT'" />
    <!-- sidebar toggle -->
    <AppButtonIcon v-if="!isMobile" :icon="setIcon" class="toggle-sidebar" @click="toggleSidebar" />
  </nav>
</template>

<script>
// Utitlities
import { authComputed } from 'Store/helpers'
import MobileBreakpointControl from 'Mixins/MobileBreakpointControl'
// Components
import AppButtonIcon from 'Ui/AppButtonIcon'
import TheSidebarMenuTeam from './components/TheSidebarMenuTeam'
import TheSidebarMenuClient from './components/TheSidebarMenuClient'

export default {
  name: 'TheSidebar',

  components: {
    AppButtonIcon,
    TheSidebarMenuTeam,
    TheSidebarMenuClient,
  },

  mixins: [MobileBreakpointControl],

  data() {
    return {
      isOpen: false,
      closeWidth: 80,
      openWidth: 262,
    }
  },

  methods: {
    toggleSidebar() {
      if (this.isOpen) this.toggleMainPadding(null, this.closeWidth)
      if (!this.isOpen) this.toggleMainPadding(null, this.openWidth)
      this.isOpen = !this.isOpen
    },

    toggleMainPadding(event, width) {
      const mainApp = document.querySelector('.diy-app__main')

      if (!this.isMobile) {
        if (width) mainApp.style.paddingLeft = `${width}px`
        if (!width && !this.isOpen) mainApp.style.paddingLeft = `${this.closeWidth}px`
      } else {
        mainApp.style.paddingLeft = `0px`
      }
    },
  },

  computed: {
    ...authComputed,
    setIcon() {
      return !this.isOpen ? 'far fa-angle-double-right' : 'far fa-angle-double-left'
    },

    sideBarWith() {
      return !this.isOpen ? '80px' : '262px'
    },

    sidebarStatus() {
      return this.isOpen && 'open'
    },
  },

  mounted() {
    const sidebar = this.$el
    const topbar = document.querySelector('.diy-topbar')
    sidebar.style.top = `${topbar.offsetHeight}px`
    // setting listeners
    this.toggleMainPadding()
    // this.toggleSidebar()
    window.addEventListener('resize', this.toggleMainPadding)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.toggleMainPadding)
  },
}
</script>

<style scoped>
.diy-sidebar {
  position: fixed;
  left: 0;
  width: 80px;
  max-width: 100%;
  height: 100%;
  padding: 20px;
  min-height: 100vh;
  border-right: 1px solid var(--c-secondary-400);
  background-color: #fff;
  transition: var(--transition-cubic-300);
}

.diy-sidebar.open {
  width: 262px;
}

.toggle-sidebar {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  right: -15px;
  line-height: 10px;
  color: #fff;
  margin: auto;
  border-radius: 50%;
  background-color: var(--c-primary);
  transform: translateY(-50%);
}

@media (max-width: 680px) {
  .diy-sidebar {
    top: unset !important;
    bottom: 0;
    width: 100%;
    border: none;
    border-top: 1px solid var(--c-secondary-300);
    height: auto;
    padding: 0 5px;
    min-height: unset;
    background-color: #fff;
    z-index: 1;
  }
}
</style>
